
// Auto-generated config.ts file
export default {
    API_KEY: "bltd0c446b7f57a323a",
    DELIVERY_TOKEN: "cs85595a33842784fc6d8e896d",
    ENVIRONMENT: "preview",
    API_HOST: "dev11-cdn.csnonprod.com",
    PREVIEW_TOKEN: "cs77a0ef3a5ee8cf672b5ef6dc",
    APP_HOST: "https://dev11-app.csnonprod.com",
    TARGET_APP_URL: "http://localhost:3006",
    STACK_NAME: "Manual Testing Stack",
    ORG_UID: "blt3e74124d8fed8e1c",
    BRANCH: "main",
};